import {getAxiosResponse} from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import store from "../../redux/store";

export async function isAllowedToEditSegmentAsync(project, phase, targetAssetData) {
    const currentUser = store.getState()?.customer_bootstrap_data?.value?.user;
    return await getAxiosResponse(APIUrls.GET_FULL_USER_BY_ID(currentUser.userId)).then((res) => {
        let userDetails = res.data.data?.resource;
        return getAxiosResponse(APIUrls.CUSTOMER_ORG_PREFERENCE + `?preference=ENABLE_REVIEWER_EDITING&deptId=${project.userGroup.id}`).then(res => {
            let editPreference = res?.data?.data;
            let isAllowed = false
            if (userDetails?.roleSet?.customerType) {
                isAllowed = (editPreference && userDetails.permissions.PROJECT_LANGUAGE_APPROVE_OR_REQUEST_REVISION && (editPreference.status === "true") &&
                    (userDetails.roleSet.value === "ROLE_CUSTOMER" || userDetails.roleSet.value === "ROLE_CUSTOMER_PROJECT_MANAGER" || userDetails.roleSet.value === "ROLE_CUSTOMER_SYSTEM" || isPhaseAssignedUser(phase)));
            } else if (userDetails?.roleSet?.vendorType) {
                isAllowed = (!isApprovalPhase(phase) && phase.assigneeType.code === "vendor")
            }
            if ((isAllowed && targetAssetData?.status === "APPROVED")) {
                isAllowed = false;
            }
            return isAllowed;
        })
    });
}

function isPhaseAssignedUser(phase) {
    if (phase.hasOwnProperty("assignedToCurrentUser")) {
        return phase.assignedToCurrentUser;
    }
    const currentUser = store.getState()?.customer_bootstrap_data?.value?.user;
    return phase.assigneeUsers.map(assignUser => assignUser.userId).filter(id => currentUser.userId == id).length !== 0;
}

function isApprovalPhase(phase) {
    if (phase.hasOwnProperty("approvalPhase")) {
        return phase.approvalPhase;
    } else {
        return phase.isApprovalPhase;
    }
}
